<script>
    import Fa from "svelte-fa";
    import { faRightFromBracket, faStar, faSpinner } from "@fortawesome/free-solid-svg-icons";
    import { createEventDispatcher } from "svelte";
  
    export let signedIn;
    export let devMode;
    export let avatar;
    export let userId;
    export let userEmail;
    export let gold;
    export let platinum;
    export let admin;
    export let referredUsers;
    export let showProfileMenu;
  
    const dispatch = createEventDispatcher();
  
    function handleSignInClick() {
      dispatch("signin");
    }
    function handleSignOutClick() {
      dispatch("signout");
    }
    function handleAvatarError(e) {
      dispatch("avatarError", e);
    }
    function toggleProfileMenu() {
      dispatch("toggleProfileMenu");
    }
    function handleUpgradeClick() {
      dispatch("upgrade");
    }
    function handleManageSubscription() {
      dispatch("manageSubscription");
    }
  </script>
  
  <header class="navbar">
    <div class="navbar-left">
      <img class="logo" src="cloaktwo.png" alt="AI Cloaker Logo" />
      <h2 class="navbar-title">AI Cloaker</h2>
    </div>
  
    <div class="navbar-right">
      {#if !signedIn && !devMode}
        <button class="signin-btn" on:click={handleSignInClick}>Sign in</button>
      {:else}
        <div class="avatar-wrapper">
          <img
            class="avatar"
            src={avatar}
            alt="User Avatar"
            on:error={handleAvatarError}
            on:click={toggleProfileMenu}
          />
          {#if showProfileMenu}
            <div class="profile-menu">
              <p><strong>Referral Code:</strong> {userId}</p>
              <p><strong>Email:</strong> {userEmail}</p>
              {#if admin}
                <p><strong>Status:</strong> Admin</p>
              {:else if platinum}
                <p><strong>Status:</strong> Platinum</p>
              {:else if gold}
                <p><strong>Status:</strong> Gold</p>
              {:else}
                <p><strong>Status:</strong> Free tier</p>
              {/if}
  
              <p><strong>Referred Users:</strong> {referredUsers}</p>
  
              <button class="signout-btn" on:click={handleSignOutClick}>
                <Fa icon={faRightFromBracket} />
                Sign Out
              </button>
            </div>
          {/if}
        </div>
  
        {#if admin}
          <div class="premium-badge admin-badge">
            <Fa icon={faStar} />
            <span>Admin</span>
          </div>
        {:else if platinum}
          <div class="premium-badge platinum-badge">
            <Fa icon={faStar} />
            <span>Platinum</span>
          </div>
        {:else if gold}
          {#if referredUsers >= 5}
            <!-- Show "Upgrade Ready!" if user can claim platinum -->
            <button
              class="upgrade-ready-btn"
              on:click={handleManageSubscription}
            >
              <span class="gold-platinum-shimmer">Upgrade Ready!</span>
            </button>
          {:else}
            <button
              class="manage-gold-btn"
              on:click={handleManageSubscription}
            >
              Manage Gold
            </button>
          {/if}
        {:else}
          <button
            class="upgrade-btn"
            on:click={handleUpgradeClick}
          >
            Upgrade
          </button>
        {/if}
      {/if}
    </div>
  </header>
  
  <style>
    .navbar {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #0a0b0e;
      padding: 0.5rem 2rem;
      border-bottom: 1px solid #424867;
    }
    .navbar-left {
      display: flex;
      align-items: center;
      gap: 1rem;
    }
    .logo {
      width: 48px;
      height: auto;
      cursor: pointer;
    }
    .navbar-title {
      font-size: 1.6rem;
      margin: 0;
      background: linear-gradient(120deg, #646cff, #ff6b6b);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .navbar-right {
      display: flex;
      align-items: center;
      gap: 1rem;
      position: relative;
    }
    .avatar-wrapper {
      position: relative;
    }
    .avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      object-fit: cover;
      border: 2px solid #424867;
      cursor: pointer;
    }
    .avatar:hover {
      border-color: #646cff;
    }
    .profile-menu {
      position: absolute;
      top: 48px;
      right: 0;
      background: #1a1c22;
      border: 1px solid #424867;
      border-radius: 8px;
      padding: 1rem;
      width: 250px;
      z-index: 10;
      display: flex;
      flex-direction: column;
      text-align: center;
      align-items: center;
    }
    .profile-menu p {
      margin: 0.4rem 0;
      color: #e2e8f0;
      font-size: 0.9rem;
      word-wrap: break-word;
    }
  
    .signin-btn {
      background: #424867;
      color: #e2e8f0;
      border: none;
      padding: 0.6rem 1rem;
      border-radius: 8px;
      cursor: pointer;
    }
    .signout-btn {
      background: #424867;
      color: #e2e8f0;
      border: none;
      padding: 0.6rem 1rem;
      border-radius: 8px;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 0.5rem;
      margin-top: 1rem;
    }
    .premium-badge {
      border-radius: 8px;
      padding: 0.5rem 1rem;
      display: flex;
      align-items: center;
      gap: 0.5rem;
      color: #fff;
    }
    .gold-badge {
      background: #f0b828; /* goldish color */
    }
    .platinum-badge {
      background: #b5b6b7; /* silverish */
    }
    .admin-badge {
      background: #d22b2b; /* red for admin */
    }
    .upgrade-btn {
      background: linear-gradient(135deg, #ff7f50, #fd5e53);
      color: white;
      border: none;
      border-radius: 8px;
      padding: 0.75rem 1.5rem;
      cursor: pointer;
      font-size: 1rem;
      display: flex;
      align-items: center;
      gap: 0.5rem;
      transition: 0.3s ease;
    }
    .upgrade-btn:hover {
      box-shadow: 0 0 15px rgba(255, 127, 80, 0.4);
    }
    .manage-gold-btn {
      background: #f0b828;
      color: #fff;
      padding: 0.75rem 1.5rem;
      border: none;
      border-radius: 8px;
      cursor: pointer;
    }
    .manage-gold-btn:hover {
      box-shadow: 0 0 15px rgba(240, 184, 40, 0.4);
    }
    .upgrade-ready-btn {
      background: linear-gradient(135deg, #f0b828 0%, #b5b6b7 100%);
      color: #fff;
      border: none;
      border-radius: 8px;
      padding: 0.75rem 1.5rem;
      cursor: pointer;
      font-size: 1rem;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 0.5rem;
      transition: 0.3s ease;
    }
    .upgrade-ready-btn:hover {
      box-shadow: 0 0 20px rgba(240, 184, 40, 0.4);
    }
    .gold-platinum-shimmer {
      background: linear-gradient(
        90deg,
        #ffd700,
        #ff8c00,
        #b5b6b7,
        #ffd700
      );
      background-size: 400% auto;
      animation: dualShine 3s linear infinite;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      color: transparent;
      text-shadow: 0 0 4px rgba(255, 255, 255, 0.9);
    }
    @keyframes dualShine {
      0% {
        background-position: -200% center;
      }
      100% {
        background-position: 200% center;
      }
    }
  </style>
  